// Determine the base API route based on the environment
export const getApiRoute = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8080';
  }
  return window.location.origin;
};

// Export the base route as a constant
export const HOST = getApiRoute();
export const API_ROUTE = `${HOST}/wp-json/api_front/v1`;
